// "Who can see these photos": none = Private (me + admin), Family, Guests (implies Family). Admin always sees.
export const WhoCanSee = ({ space, onChange, locked }) => {
  const fam = space === "family" || space === "guest";
  const guest = space === "guest";
  const box = (key, label, checked, onToggle, disabled) => (
    <label className={`who-box ${disabled ? "opacity-60" : ""}`}>
      <input type="checkbox" checked={checked} disabled={disabled} onChange={onToggle} data-testid={`who-can-see-${key}`} /> {label}
    </label>
  );
  return (
    <div className="who-can-see" data-testid="who-can-see">
      <span className="who-title">Who can see these photos</span>
      <div className="flex flex-wrap gap-x-5 gap-y-2">
        {box("guests", "Guests", guest, () => onChange(guest ? "family" : "guest"), locked)}
        {box("family", "Family", fam, () => onChange(fam ? "private" : "family"), locked || guest)}
        {box("admin", "Admin", true, () => {}, true)}
      </div>
      <small data-testid="who-can-see-summary">
        {locked ? "Set by the album. Change it from the album's menu." : guest ? "Guests, family and admin" : fam ? "Family and admin" : "Only you and the admin (Private)"}
      </small>
    </div>
  );
};
